import { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);
const STORAGE_KEY = "bbb_cart";

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || []; } catch { return []; }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }, [items]);

  const add = (service) => {
    setItems((prev) => (prev.find((i) => i.id === service.id) ? prev : [...prev, service]));
    setOpen(true);
  };
  const remove = (id) => setItems((prev) => prev.filter((i) => i.id !== id));
  const clear = () => setItems([]);

  const dueNow = items.reduce(
    (s, i) => s + (i.checkout_type === "deposit_approval" ? Number(i.deposit_amount || 0) : Number(i.price || 0)), 0);

  return (
    <CartContext.Provider value={{ items, add, remove, clear, open, setOpen, dueNow }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
